import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { fotActions } from "@store/fot";
import style from "../views-css/CardHomeStock.module.css";
import func from "@uikit/func";
import useFeatureTags from "../custom-hooks/useFeatureTags";

function CardHomeStock(props) {
  const dispatch = useDispatch();
  const feature_tags = useFeatureTags();

  const editorIdArr = useSelector(state => state.fot.editorIdArr);
  const disableAddPreview = useSelector(state => state.fot.disableAddPreview);
  const userMe = useSelector(state => state.editor.me);
  const mode = useSelector(state => state.fot.mode);
  const isShare = useSelector(state => state.fot.isShare);
  const setEditorIdArr = val => {
    dispatch(fotActions.setEditorIdArr(val));
  };
  const setSaasEditorId = val => {
    dispatch(fotActions.setSaasEditorId(val));
  };
  const [showTradeBtns, setShowTradeBtns] = useState(false);
  const [permissiionToBuyStock, setPermissiionToBuyStock] = useState(false);

  const shareClass = isShare ? style["share"] : props.locus === "saas" ? style["preview"] : "";

  const container = {
    show: {
      transition: {
        staggerDirection: -1,
        staggerChildren: 0.01,
      },
    },
    hide: {
      transition: {
        staggerChildren: 0.01,
      },
    },
  };
  const tradeOptionsItem = {
    init: {
      opacity: 0,
      y: "120px",
    },
    show: {
      opacity: 1,
      y: "0",
    },
    hide: {
      opacity: 0,
      y: "120px",
      transition: {
        duration: 0.25,
        type: "spring",
        ease: "easeOut",
      },
    },
  };
  const sellItem = tradeOptionsItem;
  const buyItem = tradeOptionsItem;
  sellItem.init.y = "80px";
  sellItem.hide.y = "80px";
  buyItem.init.y = "40px";
  buyItem.hide.y = "40px";

  const opacityItem = {
    init: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        type: "spring",
        ease: "easeInOut",
      },
    },
    hide: {
      opacity: 0,
      transition: {
        duration: 0.5,
        type: "spring",
        ease: "easeOut",
      },
    },
  };
  const clickTrade = () => {
    setShowTradeBtns(true);
  };
  const clickBuyBtn = () => {
    const data = {
      editorId: props.editorId,
      content: props.content,
    };
    const arr = [...editorIdArr, data];
    setSaasEditorId(`${props.locus}${props.editorId}`);
    setEditorIdArr(arr);
    setShowTradeBtns(false);
  };

  const checkPermissionToBuyStock = () => {
    if (mode !== "editorMode") {
      setPermissiionToBuyStock(true);
      return;
    }
    const components = (userMe?.profile?.permissions || []).find(x => x.key === "components")?.value;
    if (!components) return;
    if (components.find(x => x === "brain_studios_stock_purchase")) {
      setPermissiionToBuyStock(true);
    }
  };

  useEffect(() => {
    // check for permission to buy stocks
    checkPermissionToBuyStock();
  }, [mode, userMe?.profile?.permissions]);

  return (
    <section className={`CardHomeStock ${style[props.className]} ${props.fontSize} ${shareClass}`}>
      <div className={feature_tags.showBuyButton ? "CardHomeStockBox" : ""}>
        {/* {props.locus !== 'saas' && (
          <div className="CardHomeStockPanel">
            <span className="CardHomeStockPanelTitle">Stock Info</span>
            <span className="CardHomeStockPanelAction" onClick={handleDelete}>
              <img src={closeIcon} width="24" height="24" alt="delete" />
            </span>
          </div>
        )} */}
        <div className="CardHomeStockTop">
          <div className="CardHoeStockInfo">
            <div>
              <p className="CardHomeStockName">{!func.isEmpty(props.content?.name) ? props.content.name : "-"}</p>
              <p className="CardHomeStockSymbol">{!func.isEmpty(props.content?.symbol) ? props.content.symbol : "-"}</p>
            </div>
            <div className="CardHomeStockLogo">
              <img
                src={props.content?.logo}
                className="CardHomeStockImg"
                onLoad={props.handleImageLoaded}
                onError={props.handleImageLoaded}
                alt="logo"
              />
            </div>
          </div>
          <div className="CardHomeStockContent">
            <p className="CardHomeStockPrice">{!func.isEmpty(props.content?.price) ? props.content.price : "-"}</p>
            <p className="CardHomeStockVolumeNum">{props.content?.volume}</p>
          </div>
          {/* <p>{props.content.summary}</p> */}
          {feature_tags.showBuyButton && (
            <div
              className={`CardHomeStockBottomFixed ${
                disableAddPreview || props.locus === "saas" ? "" : "showPreviewBtn"
              }`}
            >
              {/* <p className="CardHomeStockStats">Stats</p> */}
              {/* <div className="CardHomeStockVolumeContent">
              <p className="CardHomeStockVolume">Today's volume</p>
              <p className="CardHomeStockVolumeNum">{props.content.volume}</p>
            </div> */}
              {/* <button className="CardHomeStockTradeBtn" onClick={clickTrade}>Trade</button> */}
              <AnimatePresence>
                {!showTradeBtns ? (
                  <motion.div
                    key="cardHomeStockCancelBtn"
                    variants={opacityItem}
                    initial="init"
                    animate="show"
                    exit="hide"
                    style={{ width: "100%" }}
                  >
                    <Button
                      disabled={!permissiionToBuyStock || (!disableAddPreview && props.locus !== "saas")}
                      className="CardHomeStockTradeBtn"
                      onClick={clickTrade}
                      shape="round"
                      size="large"
                    >
                      Trade
                    </Button>
                  </motion.div>
                ) : (
                  <div className="CardHomeStockTradeBtnGroup">
                    <motion.div
                      key="cardHomeStockTradeContainer"
                      variants={container}
                      initial="init"
                      animate="show"
                      exit="hide"
                      style={{ width: "100%" }}
                    >
                      <motion.div key="cardHomeStockTradeOptionsBtn" variants={tradeOptionsItem}>
                        <Button
                          className="CardHomeStockTradeBtn CardHomeStockTradeOptionsBtn"
                          shape="round"
                          size="large"
                        >
                          Trade Options
                        </Button>
                      </motion.div>
                      <motion.div key="cardHomeStockSellBtn" variants={sellItem}>
                        <Button className="CardHomeStockTradeBtn CardHomeStockSellBtn" shape="round" size="large">
                          Sell
                        </Button>
                      </motion.div>
                      <motion.div key="cardHomeStockBuyBtn" variants={buyItem}>
                        <Button
                          className="CardHomeStockTradeBtn CardHomeStockBuyBtn"
                          shape="round"
                          size="large"
                          onClick={clickBuyBtn}
                        >
                          Buy
                        </Button>
                      </motion.div>
                    </motion.div>

                    <motion.div
                      key="cardHomeStockCancelBtn"
                      variants={opacityItem}
                      initial="init"
                      animate="show"
                      exit="hide"
                      style={{ width: "100%" }}
                    >
                      <Button
                        className="CardHomeStockCancelBtn"
                        onClick={() => setShowTradeBtns(false)}
                        icon={<CloseOutlined />}
                        type="ghost"
                        shape="round"
                        size="large"
                      ></Button>
                    </motion.div>
                  </div>
                )}
              </AnimatePresence>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default CardHomeStock;
